
import { EXTRA_OPTION } from '@/utils/EndPoint'
import Vue from 'vue'
export default Vue.extend({
  name: EXTRA_OPTION,
  props: ['additionalOption', 'extraOptions', 'price'],
  methods: {
    addExtraOption (event: any, extraOption: any) {
      if (event.target.checked) { // 선택되었을 경우
        this.extraOptions[extraOption.menuOptionCode] = extraOption
      } else {
        delete this.extraOptions[extraOption.menuOptionCode]
      }
      this.$emit('update:price', this.price + (extraOption.price * (event.target.checked ? 1 : -1)))
    }
  }
})
